// chartData.ts
import type { ChartData, ChartOptions } from "chart.js";

// 1. Most Popular Offers
export const popularOffersData: ChartData<"bar"> = {
  labels: [
    "Sushi Hub",
    "Burger Lane",
    "Pasta Point",
    "Tandoori Town",
    "Vegan Vibes",
  ],
  datasets: [
    {
      label: "Bookings",
      data: [420, 380, 300, 270, 250],
      backgroundColor: "#ef6c00",
    },
  ],
};

export const popularOffersOptions: ChartOptions<"bar"> = {
  responsive: true,
  plugins: {
    legend: { display: false },
  },
  scales: {
    x: {
      ticks: {
        callback: function (value: any, index: number, ticks: any[]) {
          const label = this.getLabelForValue(value);
          const maxChars = 20;
          return label.length > maxChars
            ? label.substring(0, maxChars) + "..."
            : label;
        },
      },
      grid: {
        display: false, // remove vertical grid lines
      },
    },
    y: {
      beginAtZero: true,
      grid: {
        display: false, // remove horizontal grid lines
      },
    },
  },
};

// 2. Booking Peak Times
export const peakTimesData: ChartData<"bar"> = {
  labels: ["9 AM", "11 AM", "1 PM", "3 PM", "5 PM", "7 PM", "9 PM"],
  datasets: [
    {
      label: "Bookings",
      data: [20, 25, 35, 40, 60, 55, 30],
      backgroundColor: "#42a5f5",
    },
  ],
};

export const peakTimesOptions: ChartOptions<"bar"> = {
  responsive: true,
  plugins: {
    legend: { display: false },
  },
  scales: {
    y: { beginAtZero: true },
  },
};

// 3. Member Engagement
export const engagementData: ChartData<"bar"> = {
  labels: ["Login Daily", "Login Weekly", "Booking Weekly", "No Activity"],
  datasets: [
    {
      label: "Users",
      data: [160, 120, 80, 40],
      backgroundColor: "#66bb6a",
    },
  ],
};

export const engagementOptions: ChartOptions<"bar"> = {
  responsive: true,
  plugins: {
    legend: { display: false },
  },
  scales: {
    x: {
      grid: {
        display: false, // remove vertical grid lines
      },
    },
    y: {
      beginAtZero: true,
      grid: {
        display: false, // remove horizontal grid lines
      },
    },
  },
};

// 4. Cancellation Patterns
export const cancellationData: ChartData<"bar"> = {
  labels: ["Morning", "Afternoon", "Evening", "Night"],
  datasets: [
    {
      label: "Cancellations",
      data: [15, 25, 10, 5],
      backgroundColor: "#ef5350",
    },
  ],
};

export const cancellationOptions: ChartOptions<"bar"> = {
  responsive: true,
  plugins: {
    legend: { display: false },
  },
  scales: {
    y: { beginAtZero: true },
  },
};
